import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { _ListGallery } from "../../models/fieldSettings";
import { DB_POSTFIX, getFileLiveUrl } from "../../utils";
import LoaderIcon from "../../utils/LoaderIcon";
import { ServiceUrl } from "../../utils/serviceUrl";
import axios from "axios";
import PsContext from "../../context";
import NextPage from "./nextPage";
import PopupGallery from "./popupGallery";

const GalleryList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [viewModal, setViewModal] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    axios
      .get(ServiceUrl.LIST_GALLERY + "?sadb=" + DB_POSTFIX + "&all=1")
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setLoader(false);
        }
      });
  };

  const viewGallery = (data) => {
    setViewData(data);
    setViewModal(true);
  };

  return (
    <>
      <section>
        <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
          <Row>
            <h5
              style={{
                color: `${context.settingValue("web_site_header_textcolor")}`,
              }}
            >
              Gallery
            </h5>
            <hr />
            {loader && <LoaderIcon />}

            {/* NextPage */}
            {context.settingValue("web_site_gallery_list_page_single") ==
              "nextpage" && <NextPage dataSource={dataList} />}
            {/* NextPage */}

            {/* PopUp */}
            {context.settingValue("web_site_gallery_list_page_single") ==
              "popup" &&
              dataList.map((item, i) => {
                return (
                  <Col
                    md={4}
                    className="mb-3"
                    onClick={() => viewGallery(item)}
                  >
                    <Card className="card-hover">
                      <Card.Img
                        src={getFileLiveUrl(item.feature_image)}
                        style={{ height: "200px" }}
                      />
                      <Card.Body
                        className="text-center fw-bold"
                        style={{ color: "black", overflow: "auto" }}
                      >
                        {item.title}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            {/* NextPage */}
          </Row>
        </div>
        {viewModal && (
          <PopupGallery
            view={viewModal}
            onHide={() => setViewModal(false)}
            dataSource={viewData}
          />
        )}
      </section>
    </>
  );
};

export default GalleryList;
